import { render, staticRenderFns } from "./EventCancellationPolicy_es.vue?vue&type=template&id=c6c3c004&"
import script from "./EventCancellationPolicy_es.vue?vue&type=script&lang=js&"
export * from "./EventCancellationPolicy_es.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports